<template>
  <main class="main main--has-floating-buttons">
    <portal to="headerTitle">
      iCal
    </portal>
    <template v-if="config !== null">
      <card :title="$t('admin.interfaces.pageICal.card.general')" cols="12 6@desktop" rows="1">
        <card-badge tooltip="This feature is deprecated and will be removed in a future version." color="orange">Deprecated</card-badge>
        <hm-card-inner :full-size="true">
          <span class="info-text info-text--full-size info-text--no-margin col-12">This feature is <b>deprecated</b>. This means it is not actively maintained any more and it's solely for backwards compatibility. It may be removed at any point in time, without prior notice.</span>
        </hm-card-inner>
        <hm-card-inner>
          <hm-input-toggle :label="$t('admin.interfaces.pageICal.enabled')"
                           :enabled-title="$t('enabled')"
                           :disabled-title="$t('disabled')"
                           v-model="config.enabled"
                           cols="12 6@hd start-1"
                           name="enabled" />
        </hm-card-inner>
      </card>
      <hm-col :grid="true" cols="12" class="grid--row-gap">
        <template v-for="itConfig in config.interfaces">
          <card :title="itConfig.sourceName"
                :key="itConfig.id"
                rows="2"
                cols="12 6@desktop"
                card-type="record"
                @delete="onDeleteInterface(itConfig.id)">
            <hm-card-inner>
              <!-- :disabled="!hasLicense('iCalImport')" -->
              <hm-input-toggle v-if="!itConfig.enabled"
                               :label="$t('admin.interfaces.pageICal.enabled')"
                               v-model="itConfig.enabled"
                               :disabled="!hasLicense('iCalImport') || !config.enabled || isEmpty(itConfig.sourceName)"
                               cols="12 6@hd start-1"
                               name="enabled" />
              <hm-input-toggle v-else
                               :label="$t('admin.interfaces.pageICal.enabled')"
                               v-model="itConfig.enabled"
                               cols="12 6@hd start-1"
                               name="enabled" />
              <hm-input :label="$t('admin.interfaces.pageICal.sourceName')"
                        v-model="itConfig.sourceName"
                        :disabled="Object.values(itConfig.rooms).some((it) => !isEmpty(it))"
                        cols="12 6@hd start-1"
                        name="sourceName" />
              <hm-input-select :label="$t('admin.interfaces.pageICal.type')"
                               v-model="itConfig.type"
                               cols="12 6@hd start-1"
                               name="type"
                               enum-name="ICalInterfaceType" />
              <hm-input-select v-model="itConfig.ratePlanId" :label="$t('admin.interfaces.pageICal.ratePlanId')" name="ratePlanId" cols="12 6@hd start-1">
                <option v-for="item in hotelSettings.ratePlans.all(itConfig.ratePlanId)" :value="item.id" v-html="item.name[$shortLocale]"></option>
              </hm-input-select>
              <guest-search v-if="hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                            :required="false"
                            v-model="itConfig.travelAgent"
                            :label="$t('admin.interfaces.pageICal.travelAgent')"
                            cols="12 6@hd start-1"
                            name="travelAgent" />
            </hm-card-inner>
            <hm-card-inner>
              <hm-input-toggle v-model="itConfig.importNoName"
                               :label="$t('admin.interfaces.pageICal.importNoName')"
                               name="importNoName"
                               cols="12 6@hd start-1" />
              <hm-input-toggle v-if="['HomeAway'].includes(itConfig.type)"
                               v-model="itConfig.importTentative"
                               :label="$t('admin.interfaces.pageICal.importTentative')"
                               name="importTentative"
                               cols="12 6@hd start-1" />
              <hm-input-toggle v-if="['Booking','HomeAway','Others'].includes(itConfig.type)"
                               v-model="itConfig.importBlocked"
                               :label="$t('admin.interfaces.pageICal.importBlocked')"
                               name="importBlocked"
                               cols="12 6@hd start-1" />
              <hm-input-toggle v-if="['Others'].includes(itConfig.type)"
                               v-model="itConfig.useConfirmationInsteadOfUID"
                               :label="$t('admin.interfaces.pageICal.useConfirmationInsteadOfUID')"
                               name="useConfirmationInsteadOfUID"
                               cols="12 6@hd start-1" />
              <hm-input-toggle v-model="itConfig.createGuestProfile"
                               :label="$t('admin.interfaces.pageICal.createGuestProfile')"
                               name="createGuestProfile"
                               cols="12 6@hd start-1" />
              <hm-input-number v-model="itConfig.departureDateOffset"
                               :label="$t('admin.interfaces.pageICal.departureDateOffset')"
                               name="departureDateOffset"
                               cols="12 6@hd start-1" />
            </hm-card-inner>
            <hm-card-inner :title="$t('admin.interfaces.pageICal.card.roomUsage')">
              <template v-for="itRoomNumber in Object.keys(itConfig.rooms)">
                <hm-input v-if="!isEmpty(itConfig.rooms[itRoomNumber])"
                          :lazy="true"
                          v-model="itConfig.rooms[itRoomNumber]"
                          :key="itRoomNumber"
                          :disabled="true"
                          :label="`${$t('admin.pageRoom.iCalImportLink')} // ${$t('admin.pageRoom.roomNumber')}: ${itRoomNumber}`"
                          name="iCalImportLink"
                          cols="12" >
                  <template slot="icon-inline-right" slot-scope="slot">
                    <input-icon-button :border="true"
                                       :disabled="false"
                                       icon="edit"
                                       @click="onRouteToRoom(itRoomNumber)" />
                  </template>
                </hm-input>
              </template>
            </hm-card-inner>
            <!--
            <hm-card-inner :title="$t('admin.interfaces.pageICal.card.rooms')">
              <template v-for="itRoom in hotelSettings.rooms.all()">
                <hm-input :lazy="true"
                          v-model="itConfig.rooms[itRoom.roomNumber]"
                          :key="itRoom.roomNumber"
                          :label="`${$t('admin.pageRoom.iCalImportLink')} // ${$t('admin.pageRoom.roomNumber')}: ${itRoom.roomNumber}`"
                          name="iCalImportLink"
                          cols="12" />
              </template>
            </hm-card-inner>
            -->
          </card>
        </template>
      </hm-col>
    </template>
    <hm-floating-buttons id="actions" ref="floatingButtons">
      <hm-floating-button v-if="hasLicense('iCalImport')"
                          :label="$t('admin.interfaces.pageICal.addInterface')"
                          icon="plus"
                          color="blue"
                          @click="onCreateInterface" />
    </hm-floating-buttons>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import SaveWatchMixin from '@/mixins/SaveWatchMixin';
import Card from '../../../lib/layout/Card';
import HmInputCheckbox from '../../../lib/inputs/HmInputCheckbox';
import HmInputMoney from '../../../lib/inputs/HmInputMoney';
import HmCardInner from '../../../lib/layout/HmCardInner';
import HmTextarea from '../../../lib/inputs/HmTextarea';
import HmTable from '../../../lib/table/HmTable';
import { cloneDeep, first, isEmpty, isNil, keyBy, last, mapValues, sortBy } from 'lodash';
import HmInputSelect from '../../../lib/inputs/HmInputSelect';
import GuestSearch from '../../../lib/inputs/GuestSearch';
import HmInputNumber from '../../../lib/inputs/HmInputNumber.vue';
import HmInputRange from '../../../lib/inputs/HmInputRange.vue';
import HmCol from '../../../lib/layout/HmCol.vue';
import HmCardInnerLine from '../../../lib/layout/HmCardInnerLine.vue';
import HmFloatingButton from '../../../lib/inputs/HmFloatingButton.vue';

export default {
  name: 'PageICal',
  components: { HmFloatingButton, HmCardInnerLine, HmCol, HmInputRange, HmInputNumber, GuestSearch, HmInputSelect, HmTable, HmTextarea, HmCardInner, HmInputMoney, HmInputCheckbox, Card },
  mixins: [HotelmeisterMixin, SaveWatchMixin],

  autosave: [
    {
      name: 'config',
      variable: 'config',
      event: 'hotelSettings.update',
      fn: function (cbSaveComplete) {
        cbSaveComplete();

        const toSave = cloneDeep(this.config);

        toSave.interfaces.forEach((it) => {
          it.rooms = Object.entries(it.rooms || []).map(itVal => ({ roomNumber: itVal[0], iCalLink: itVal[1] }));
        });

        this.axios.put(this.serviceUrls.interfaces.iCal.list(this), toSave)
          .then((response) => {
            this.showMessages(response);
            cbSaveComplete();
          })
          .catch((error) => {
            if (isNil(error.response)) this.showErrorMessage();
            this.showMessages(error.response);
            cbSaveComplete();
          });
      },
    },
  ],

  data() {
    return {
      config: null,
    };
  },

  computed: {
    enums: function () {
      return this.$store.getters['enums/enums'];
    },
  },

  watch: {
  },

  created: function () {
    this.loadData();
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    isNil,
    loadData() {
      return this.axios.get(this.serviceUrls.interfaces.iCal.list(this))
        .then((response) => {
          const tmp = response.data.data;
          (tmp.interfaces || []).forEach((it) => {
            it.rooms = mapValues(keyBy((it.rooms || []), 'roomNumber'), 'icalLink');
            it.travelAgent = isNil(it.travelAgent) ? null : it.travelAgent.guestProfileId;
          });

          this.config = tmp;
        });
    },
    onDeleteInterface(iCalInterfaceId) {
      this.__pauseAutosave('config');
      this.axios.delete(this.serviceUrls.interfaces.iCal.get(this, iCalInterfaceId))
        .then((response) => {
          this.showMessages(response);
          this.showSuccessMessage();
        })
        .catch((error) => {
          this.showMessages(error.response);
        })
        .finally(() => {
          this.loadData().then(() => {
            this.__continueAutosave('config');
          });
        });
    },
    onCreateInterface() {
      this.__pauseAutosave('config');
      this.axios.post(this.serviceUrls.interfaces.iCal.list(this))
        .then((response) => {
          this.showMessages(response);
          this.showSuccessMessage();
        })
        .catch((error) => {
          this.showMessages(error.response);
        })
        .finally(() => {
          this.loadData().then(() => {
            this.__continueAutosave('config');
          });
        });
    },
    onRouteToRoom(itRoomNumber) {
      const room = this.findHotelSettingById('rooms', itRoomNumber, 'roomNumber');
      if (isNil(room)) {
        this.showErrorMessage();
        return;
      }
      this.$router.push({
        name: 'room',
        params: {
          roomId: room.id,
        },
      });
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/interfaces/PageICal.vue